const SESSION_TIMEOUT = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
const LAST_ACTIVITY_KEY = "lastActivityTime";

export const initializeSessionManager = () => {
  // Set initial activity time
  updateLastActivity();

  // Add event listeners for user activity
  const events = ["mousedown", "keydown", "scroll", "touchstart"];
  events.forEach((event) => {
    document.addEventListener(event, updateLastActivity);
  });

  // Start checking for session timeout
  startSessionCheck();
};

export const updateLastActivity = () => {
  localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
};

const startSessionCheck = () => {
  setInterval(checkSession, 60000); // Check every minute
};

const checkSession = () => {
  const lastActivity = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY) || "0");
  const currentTime = Date.now();

  if (currentTime - lastActivity > SESSION_TIMEOUT) {
    endSession();
  }
};

const endSession = () => {
  // Clear all session data
  localStorage.clear();
  // Redirect to login page
  window.location.href = "/login";
};
